import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import TolTag from '../shared/tol-tag';
import dt, { useIsXXLarge } from '../../shared/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;

  ${props => dt(props).theme.isXXLarge && `
    flex-direction: row;
    align-items: center;
  `};

  > span {
    margin-bottom: 4px;
  }
`;

const Secondary = styled.span`
  ${props => dt(props).theme.isMobile && `
    margin-bottom: 8px;
  `};

  &&, & > a {
    color: ${props => props.theme.secondaryColor};
  }
`;

const Separator = styled(Secondary)`
  margin: 0 5px;
`;

const TagSeparator = styled.span`
  margin: 0 0 2px 5px;
`;

const TolTagWrapper = campaign => (
  <TagSeparator>
    <TolTag {...campaign} />
  </TagSeparator>
);

export default function WireCaption({ wire }) {
  const {
    category,
    series,
    campaign,
    isSponsored,
  } = wire;
  const caption = {};
  if (category || series) {
    const seriesTitle = _.get(series, 'title');
    caption.text = seriesTitle || _.get(category, 'name');
    caption.url = seriesTitle ? `/${series.slug}` : `/categories/${category.slug}`;
  }
  const isXXLarge = useIsXXLarge();

  return (
    <ThemeProvider theme={{ ...theme }}>
      <Container>
        {!!caption.url && (
          <span className="main">
            <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
          </span>
        )}
        {!!(caption.url && isSponsored && isXXLarge) && <Separator className="separator">&bull;</Separator>}
        {!!(isSponsored) && (
          <Secondary>
            sponsored
          </Secondary>
        )}
        {!!campaign && <TolTagWrapper {...campaign} />}
      </Container>
    </ThemeProvider>
  );
}

WireCaption.propTypes = {
  wire: PropTypes.shape({
    isSponsored: PropTypes.bool.isRequired,
    category: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    series: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
    campaign: PropTypes.shape({
      name: PropTypes.string.isRequired,
      sentDate: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
